<script lang="ts">
  import type {Poem} from '../../types'
  import {t} from '../../i18n'
  import Editor from '../../shared/Editor.svelte'
  import {titleFromContent} from './utils'
  import ValidationMessage from '../../shared/ValidationMessage.svelte'
  import '../../../css/add-poem.css'

  export let poem: Poem
  export let stepTo: (e: Event, stepIndex: number) => void

  let errors: Record<string, string[]> = {}

  $: defaultTitle = poem.id ? '' : titleFromContent(poem.content)

  export function validate(): boolean {
    if (!poem.title || poem.title.trim().length === 0) {
      errors['title'] = [t.errors.validation.required]
      return false
    }

    if (!poem.content || poem.content.trim().length === 0) {
      errors['content'] = [t.errors.validation.required]
      return false
    }

    errors = {}
    return true
  }
</script>

<div class="editor-block">
  <div class="editor__title">
    <input type="text" placeholder={t.poem.placeholder_title} value={poem.title || defaultTitle} required
           class:error-input={errors.title} oninput={e => poem.title = e.currentTarget.value}/>

    <ValidationMessage errors={errors.title}/>
  </div>

  <Editor bind:content={poem.content} placeholder={t.poem.content_placeholder} class="editable"/>
  <ValidationMessage errors={errors.content}/>
  
  <div class="step-button-wrap">
    <a class="ui button inverted" onclick={(e) => stepTo(e, 1)}>
      {t.poem.steps.continue}
    </a>
  </div>
</div>

